var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-success btn-sm icon-pencil",attrs:{"title":"Editar"},on:{"click":_vm.editar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }